const DeleteAccount = () => {
  return (
    <div className="w-full max-h-screen flex flex-col items-center mt-10 px-4 sm:px-6 md:px-10">
      {/* Logo */}
      <img
        src="/assests/ceviliyar_mainLogo.png"
        alt="ceviliyar_Logo"
        className="w-[150px] sm:w-[205px] h-auto  top-0 left-0 right-0 mx-auto mt-10 sm:mt-6"
      />

      <div className="flex flex-col md:flex-row justify-center items-center gap-8 mt-32 mb-10 ml-0 lg:ml-10 ">
        <div className="max-w-full md:max-w-[400px] lg:max-w-[500px] text-left">
          <p className="text-[28px] sm:text-[36px] md:text-[50px] font-playfair text-center md:text-left lg-text-left font-bold">
            How to delete my account?
          </p>
          <ul className="list-disc ml-5 text-gray-600 font-montserrat space-y-3 text-sm sm:text-base mt-6 mb-10">
            <li>Login to the mobile application.</li>
            <li>Click on the Accounts (3rd Icon on the bottom navigation).</li>
            <li>You will see a menu item which says "Delete Account".</li>
            <li>You will be prompted for confirmation.</li>
            <li>
              Once you say "Delete," all of your information will be deleted <br />
              immediately and you will be logged out.
            </li>
            <li>You cannot delete your account, while being on active duty.</li>
            <li>
              For Nurse/Physiotherapist: If you are not on active duty, all your information will be
              deleted immediately, except your name and role will be stored in the Visit Information
              of Patient's records.
            </li>
            <li>
              For Patients: If you are not on active duty, all your information will be deleted
              immediately, expect for your name and amount paid for the visit in the payment record
              of Nurse/Physiotherapist
            </li>
          </ul>
        </div>

        {/* Image */}
        <img
          src="/assests/deleteMy.png"
          alt="Delete Account Illustration"
          className="w-full sm:w-[350px] md:w-[450px] lg:w-[400px] h-auto mx-auto"
        />
      </div>
    </div>
  );
};

export default DeleteAccount;
